import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

import './G2Cloud.css';
import isFilled from '../../../utilities/isFilled.js';
import { getCookie } from '../../../utilities/cookies';

const Error404 = () => {
    const navigate = useNavigate();
    const[redirect, setRedirect] = useState(0)

    useEffect(() => {
        if(redirect != 0) { navigate('/') }
    }, [redirect])

    return (
        <div className='containerError'>
            <div className='cardError'>
                <div>
                  <a href="https://www.gestfrut.es/" target="_blank">
                    <img alt = "G2 Cloud ERP" src = "https://cdn.g2cloud.es/soporte/img/g2cloud_small.png" width = "316" height = "84" />
                  </a>
                </div>
                <hr size="8px" />
                <div>
                    <h1><strong>ERROR</strong></h1>
                    <img alt="Error 404" src="https://cdn.g2cloud.es/soporte/img/404-g2Cloud.jpeg" width="458" height="231"></img>
                    <p>Lo sentimos, pero no encontramos la página que buscas...</p>
                    {isFilled(getCookie("jwt"))
                        ? <button className="btn btn-primary" onClick={() =>setRedirect(1)}>Ir a la aplicación</button>
                        : <button className="btn btn-primary" onClick={() =>setRedirect(2)}>Ir al login</button>
                    }
                </div>
            </div>
        </div>
    )
}

export default Error404